import React, { useState } from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import Button from "@material-ui/core/Button";

const PlayerListDialog = ({
  players,
  selectedPlayers,
  open,
  onClose,
  onSelectedPlayersChange,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchTermChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handlePlayerCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    let newSelectedPlayers = [...selectedPlayers];
    if (isChecked) {
      newSelectedPlayers.push(event.target.value);
    } else {
      newSelectedPlayers = newSelectedPlayers.filter(
        (id) => id !== event.target.value
      );
    }
    onSelectedPlayersChange(newSelectedPlayers);
  };

  const filteredPlayers = players.filter((player) =>
    player.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="player-list-dialog-title"
    >
      <DialogTitle id="player-list-dialog-title">Select Players</DialogTitle>
      <DialogContent>
        <FormControl component="fieldset">
          <FormLabel component="legend">Search Players</FormLabel>
          <TextField
            variant="outlined"
            label="Search"
            margin="dense"
            value={searchTerm}
            onChange={handleSearchTermChange}
            fullWidth
          />
        </FormControl>
        <FormControl component="fieldset">
          <FormLabel component="legend">Players</FormLabel>
          <FormGroup>
            {filteredPlayers.map((player) => (
              <FormControlLabel
                key={player.id}
                control={
                  <Checkbox
                    value={player.id}
                    checked={selectedPlayers.includes(player.id)}
                    onChange={handlePlayerCheckboxChange}
                  />
                }
                label={player.name + " " + player.dateOfBirth}
              />
            ))}
          </FormGroup>
        </FormControl>
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
};

PlayerListDialog.propTypes = {
  players: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedPlayers: PropTypes.arrayOf(PropTypes.number).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectedPlayersChange: PropTypes.func.isRequired,
};

export default PlayerListDialog;
